module.exports = __webpack_public_path__ + "img/Trillionaire-4.ef82ba52.png";